module.exports = __webpack_public_path__ + "/hashedassets-launcher/download_teams_desktop.e7dc6516ad96cc438d4782b820e7546f.svg";